(function () {
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    if (!section) {
        return;
    }

    const factsDialog = section.querySelector(".productProtectRedesignV1FactsDialog");
    const factsOpen = section.querySelector(".productProtectRedesignV1FactsOpen");

    if (factsDialog && factsOpen) {
        const closeFacts = function () {
            factsDialog.close();
            document.body.classList.remove("noScroll");
        };

        factsOpen.addEventListener("click", function () {
            factsDialog.showModal();
            document.body.classList.add("noScroll");
        });

        section.querySelectorAll(".productProtectRedesignV1FactsDialogClose").forEach(function (element) {
            element.addEventListener("click", closeFacts);
        });

        factsDialog.addEventListener("click", function (e) {
            if (e.target === factsDialog) {
                closeFacts();
            }
        });

        factsDialog.addEventListener("close", function () {
            document.body.classList.remove("noScroll");
        });
    }

    const otpButton = section.querySelector(".productProtectRedesignV1SubscribeOtp");
    if (otpButton) {
        otpButton.addEventListener("click", async function (event) {
            event.preventDefault();
            event.stopPropagation();

            if (otpButton.classList.contains("loading") || otpButton.disabled) {
                return;
            }

            const variantId = parseInt(otpButton.dataset.variantId, 10);
            if (!variantId) {
                return;
            }

            otpButton.classList.add("loading");
            try {
                await addProduct(attachTemplateProperty(
                    {items: [{quantity: 1, id: variantId}]},
                    section
                ));
                await openCart();
            } finally {
                otpButton.classList.remove("loading");
            }
        });
    }

    const swiperEl = section.querySelector(".productProtectRedesignV1VisualSwiper");
    if (!swiperEl) {
        return;
    }

    const thumbsEl = section.querySelector(".productProtectRedesignV1Thumbs");
    const thumbsSwiper = thumbsEl ? new Swiper(thumbsEl, {
        slidesPerView: 5,
        spaceBetween: 10,
        watchSlidesProgress: true,
    }) : null;

    const swiperOptions = {
        slidesPerView: "auto",
        spaceBetween: 10,
        loop: false,
        navigation: {
            nextEl: section.querySelector(".productProtectRedesignV1NavBtn.next"),
            prevEl: section.querySelector(".productProtectRedesignV1NavBtn.prev"),
        },        
        on: {
            slideChange: function () {
                if (!section.querySelector(".productV1VisualSwiperSlide")) {
                    return;
                }

                section.querySelectorAll(".productV1VisualSwiperSlide video").forEach(element => {
                    element.pause();
                });
            }
        }
    };

    if (thumbsSwiper) {
        swiperOptions.thumbs = {
            swiper: thumbsSwiper,
        };
    }

    new Swiper(swiperEl, swiperOptions);

    section.querySelectorAll(".productV1VisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            const video = this.closest(".productV1VisualSwiperSlide").querySelector("video");

            if (!video) {
                return;
            }

            this.querySelector(".productV1VisualSwiperSlidePlay")?.remove();
            video.controls = true;
            video.play();
        });
    });
}());
